import { CustomerAction, CustomerActions } from "../actions/customer-actions";

const INITIAL_STATE: Object = {
    activeCustomer: undefined,
    customerSiblings: [],
};

export function customersReducer(state: Object = INITIAL_STATE, action: CustomerAction) {
    switch (action.type) {
        case CustomerActions.GET_CUSTOMER_SUCCESS:
            return { ...state, activeCustomer: action.payload };
        case CustomerActions.GET_CUSTOMER_SIBLINGS_SUCCESS:
            return { ...state, customerSiblings: action.payload };

        default:
            return state;
    }
}
